import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { ICompany } from '../interfaces/ICompany';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment as env } from '@env/environment';
import { HttpHeaders } from '@angular/common/http';
import { HttpErrorHandler, HandleError } from './http-error-handler';
import { tap } from "rxjs/internal/operators/tap";
import { AuthGuardService } from '../auth/auth-guard.service';
import { Store } from '@ngrx/store';
import { AuthenticationService } from '../services/AuthenticationService';

export interface ICalculatorSettings {
    ServiceFee: number;
    GlobalExpressServiceFee: number;
}

@Injectable()
export class FeeService {
    public apiAuthUrl: string;
    private apiBaseUrl: string;
    public token: string;
    private userString: string;
    private httpOptions: any;
    private handleError: HandleError;
    
    constructor(
        private http: HttpClient,
        private router: Router,
        private authenticationService: AuthenticationService,
        httpErrorHandler: HttpErrorHandler,
        private route: ActivatedRoute)
    {
        this.apiBaseUrl = env.hostApi;
        this.setHttpOptions();
    }
    
    getMemberServiceFee(userId: string, samekonomiInvoice: boolean = false): Observable<any> {
      const url =
        this.apiBaseUrl +
        'Fees/ServiceFeeFactor?userId=' +
        encodeURIComponent(userId) +
        '&samekonomiInvoice=' +
        samekonomiInvoice;

      return this.http.get<any>(url, this.httpOptions).pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
          console.log(err);
          // if (err.status == 401) {
          //   this.router.navigate(['/login']);
          // }
          return new Observable<any>();
        })
      );
    } 

    getCalculatorSettings(): Observable<ICalculatorSettings> {
      const url = this.apiBaseUrl + 'Fees/CalculatorSettings';

      return this.http.get<ICalculatorSettings>(url, {
        headers: this.httpOptions.headers
      }).pipe(
        catchError(
          (err: any) => {
            console.log(err);
            return of(null as ICalculatorSettings);
          })
      );
    }

    
    setHttpOptions() {
        var bearerToken = 'bearer ' + this.authenticationService.token;

        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': bearerToken
            })
        };
    }
}

